import axios from 'axios'
import { getToken, setToken } from '@/utils/auth'
import store from '../store';
import { main } from '../router/index';
// create an axios instance
const service = axios.create({
        baseURL: process.env.VUE_APP_BASE_API, // "/api", // url = base url + request url
        // withCredentials: true, // send cookies when cross-domain requests
        timeout: 50000 // request timeout
    })
    // request interceptor
service.interceptors.request.use(
    config => {
        try {
            if (config.Headers.token === "") {
                store.commit("initUser");
                // do something before request is sent
                if (store.state.userInfo !== undefined && store.state.userInfo !== null) {
                    config.headers['Authorization'] = "Bearer " + store.state.userInfo.token
                }
            }
            return config
        } catch (err) {
            return config
        }

    }, error => {
        // do something with request error
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        return response;
    },
    error => {
        // console.log(error.response);
        // if (error.message.includes("401")) {
        //     store.dispatch("SET_LOGOUT");
        //     window.location.href = window.location.origin + "/login";
        //     return;
        // }
        // if (error.message.includes("403")) {
        //     if (main.history.current.name !== "details") {
        //         // window.location.href = window.location.origin
        //     }
        //     return { status: 401 }
        // }
        // if (error.message.includes("504") || error.message.includes("503")) return { status: 401 };
        // if (main.history.current.name !== "login" && main.history.current.name !== "signup") {
        //     if (error.message !== 'Network Error') {
        //         store.dispatch("SET_LOGOUT");
        //         window.location.href = window.location.origin + "/login";
        //     }
        // }
        return { status: 401 }
    }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js